<template>
<!-- Site wrapper -->
<div class="wrapper">
  <cabecalho tituloPagina="Usuários" />
  <menuLateral />

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <b-button class="botoes" variant="outline-primary btn-sm mt-2" @click="incluirUsuario()" :disabled="flagsDeControle.carregandoDados.status">Incluir</b-button>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>
    <!-- Main content -->
    <section class="content">
      <!-- Default box -->
      <div class="card">
        <div class="card-body">
          <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
            <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
            <b-spinner class="ml-2" variant="danger"></b-spinner>
          </div>
          <div class="card bg-light d-flex flex-fill">
            <div class="card-header border-bottom-0">
              <form v-on:keyup.enter="buscarRegistros()">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <b-form-group label="Nome" label-for="nomeFiltro" label-align-sm="left" label-size="sm" class="mb-0"></b-form-group>
                    <b-form-input id="nome" v-model="camposFiltroPesquisa.nome" type="text" :disabled="flagsDeControle.carregandoDados.status"></b-form-input>
                  </div>
                  <div class="form-group col-md-6">
                    <b-form-group label="E-mail" label-for="emailFiltro" label-align-sm="left" label-size="sm" class="mb-0"></b-form-group>
                    <b-form-input id="email" v-model="camposFiltroPesquisa.email" type="text" :disabled="flagsDeControle.carregandoDados.status"></b-form-input>
                  </div>
                  <div class="form-group col-sm-12 col-md-6 col-lg-2">
                    <b-form-group label="Status" label-for="statusFiltro" label-align-sm="left" label-size="sm" class="mb-0"></b-form-group>
                    <b-form-select id="status" v-model="camposFiltroPesquisa.status" :options="statusFiltroOptions" :disabled="flagsDeControle.carregandoDados.status" size="sm" class="comboFonteDefault"></b-form-select>
                  </div>
                  <div class="form-group text-right mt-auto ml-auto">
                    <b-button class="botoes" variant="outline-secondary btn-sm" @click="limparFiltros()" :disabled="flagsDeControle.carregandoDados.status">Limpar</b-button>
                    <b-button class="botoes ml-1" variant="outline-primary btn-sm" @click="buscarRegistros()" :disabled="flagsDeControle.carregandoDados.status">Buscar</b-button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <default-table
            :items="listaUsuarios"
            :fields="fields"
            :sort-by="componenteOrdenacao.campo"
            :sort-direction="componenteOrdenacao.sentido"
            :busy="flagsDeControle.carregandoDados.status"
            @sortChanged="ordenarLista"
            :tbody-tr-class="tabelaSemRegistros">
            <template #empty>
              <em>Nenhum registro encontrado.</em>
            </template>
            <template #cell(f_name)="row">
              <a href="#" :class="destacarUsuarioInativo(row.item.f_status)" v-on:click.stop.prevent="editarUsuario(row.item.f_id)" :disabled="flagsDeControle.carregandoDados.status">
                <imageStream v-if="usuarioTemFoto(row.item.f_photo)" class="mr-2" rounded="circle" width="32" height="32" :imageStream="row.item.f_photo" alt="" />
                <b-img v-else class="mr-2" rounded="circle" width="32" height="32" :src="require('@/assets/img/usuario-sem-foto.png')" alt=""/>
                {{ row.item.f_name }}
              </a>
            </template>
            <template #cell()="row">
              <span :class="destacarUsuarioInativo(row.item.f_status)" :disabled="flagsDeControle.carregandoDados.status">{{ row.value }}</span>
            </template>
          </default-table>
          <pagination :fonteDeDados="componentePaginacao.fonteDeDados" :disabled="flagsDeControle.carregandoDados.status" @navegarNaPaginacao="obterDadosPaginados"/>
        </div>
      </div>
    </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</div>
<!-- ./wrapper -->
</template>

<script>
import Usuarios from './js'
export default Usuarios
</script>

<style scoped>
@import "./scss/usuarios.scss";
</style>
